// import { useState, useEffect } from 'react';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTag, faHeart, faArrowRightArrowLeft  } from '@fortawesome/free-solid-svg-icons';
import far from '@fortawesome/free-regular-svg-icons';
import Liked from "./hearts/Liked";
import NotLiked from "./hearts/NotLiked";
import { AiOutlineSwap } from "react-icons/ai";
import { useRouter } from 'next/router';
import InfiniteScroll from "react-infinite-scroll-component";
import { useState } from 'react';

export default function Home({ productsProps, getProducts, setProducts }) {

  const router = useRouter();

  const [startFrom, updateStartFrom] = useState("1");

  console.log(productsProps);

  const addNewProducts = async() => {
    const newProduct = await getProducts(startFrom);
    console.log(newProduct);
    setProducts((p) => [...p, ...newProduct]);
    updateStartFrom(startFrom + 1);
  }


  return (
    <div className={`w-full px-6 pb-6 pt-10`}>
      <div
        className={`bg-yellow text-primary text-center py-4 mb-2 font-bold font-[40px]`}
      >
        {productsProps.productTitle}
      </div>
      <div
        className={`grid grid-cols-2 md:grid-cols-12 gap-y-6 gap-x-4 md:gap-y-10 md:gap-x-14 xl:gap-x-8 w-full my-10`}
      >
        {(productsProps.products.docs.length === 0 ? (
          <div className={`mx-auto text-[60px] col-span-2 md:col-span-12`}>
            No Product
          </div>
        ) : (
          <InfiniteScroll
            dataLength={productsProps.products.docs.length}
            next={addNewProducts}
            hasMore={productsProps.products.hasNextPage}
            loader={<div className="text-center">Loading... Please Wait</div>}
            endMessage={<div className="text-center">No more products</div>}
          >
            {productsProps.products.docs.map((product, index) => (
              <div
              key={index}
              className={`col-span-1 md:col-span-4 xl:col-span-2 border border-[1px] border-solid p-2 border-yellow rounded-[20px]`}
            >
              <div
                className={`flex items-center justify-between rounded-[20px]`}
              >
                <Image
                  src={product.user.profilePicUrl}
                  layout="intrinsic"
                  alt={`${product.user.fullName}'s picture`}
                  className={`rounded-full`}
                  width={35}
                  height={35}
                />
                <div className={`text-[16px] md:text-[20px] font-medium`}>
                  {product.user.fullName}
                </div>
                <div>{product.favouriteByMe ? <Liked /> : <NotLiked />}</div>
              </div>
              <div className={`w-full text-center my-4`}>
                <Image
                  src={product.product.mainImage}
                  layout={`intrinsic`}
                  alt={product.product.name}
                  height={80}
                  width={100}
                />
                <div className={`text-[#262626] text-[16px] font-medium`}>
                  {product.product.name}
                </div>
                <div
                  className={`flex justify-center font-semibold text-[14px] items-center`}
                >
                  N{product.product.price}{" "}
                  <FontAwesomeIcon
                    icon={faTag}
                    className={`w-4 h-6 text-primary ml-2`}
                  />
                </div>
              </div>
              <button
                onClick={() => {
                  router.push("/product/" + product.product._id);
                }}
                className={`text-center w-full bg-primary flex items-center justify-center font-bold rounded-[20px] py-2 text-white text-[14px]`}
              >
                Swap <AiOutlineSwap className={`text-white text-[20px] ml-2`} />
              </button>
            </div>
            ))}
          </InfiniteScroll>
        ))}
        
      </div>
    </div>
  );
}
